import React, { useCallback, useMemo } from 'react';
import './style.less';
import { Button } from 'shared/components/Button';
import { Icon } from 'shared/components/Icon';
import { useUpdateUserOutboundSettings } from 'browser/components/Settings/Dialer/useUpdateUserOutboundSettings';
import { useAppSelector } from 'shared/store';
import { OutboundDialpad } from 'browser/components/Outbound/OutboundDialpad';
import { CallTask } from 'types';

export const ConnectedCallDetailFooter: React.FC<{
  onDialWithoutTask: (task: CallTask) => Promise<void>;
}> = ({ onDialWithoutTask }) => {
  const { settings, updateSettings } = useUpdateUserOutboundSettings();
  const { detailTask } = useAppSelector(state => state.outbound);

  const contact = detailTask?.contact;
  const isInDoNotCallList = useMemo(
    () => settings.outboundDoNotCallList?.includes(contact?.phone ?? ''),
    [contact?.phone, settings.outboundDoNotCallList],
  );

  const remove = useCallback(() => {
    updateSettings(
      'outboundDoNotCallList',
      [...(settings.outboundDoNotCallList ?? [])].filter(p => p !== contact?.phone),
    );
  }, [contact?.phone, settings, updateSettings]);

  const add = useCallback(() => {
    updateSettings('outboundDoNotCallList', [
      ...(settings.outboundDoNotCallList ?? []),
      contact?.phone,
    ]);
  }, [contact?.phone, settings.outboundDoNotCallList, updateSettings]);

  return (
    <div className="ConnectedCallDetailFooter">
      <Button
        className="ConnectedCallDetailFooter__action"
        type="ghost"
        size="middle"
        onClick={() => {
          if (isInDoNotCallList) {
            remove();
          } else {
            add();
          }
        }}
      >
        <Icon icon="block" width={20} height={20} />
        {isInDoNotCallList ? 'Remove from do not call list' : 'Do not call'}
      </Button>
      <OutboundDialpad onDialClick={onDialWithoutTask} />
    </div>
  );
};
